import { useMemo } from 'react';

import { buildAccountColorMap, type AccountColor } from '@/features/accounts/account-colors';
import { useAccounts } from '@/features/accounts/useAccounts';

/**
 * Memoized account-id -> color map, derived from the accounts list.
 *
 * Reuses `useAccounts()`'s own React Query cache entry — by the time any
 * consumer of this hook mounts, `AccountSidebar` has already made that
 * query cache-warm, so this never issues a fetch of its own; it only
 * re-derives the map when the underlying accounts data actually changes.
 */
export function useAccountColors(): Map<string, AccountColor> {
  const { data } = useAccounts();
  return useMemo(() => buildAccountColorMap(data ?? []), [data]);
}
